(function () {
  angular
    .module("akitabox.desktop.request.detail")
    .controller("RequestWorkOrderTabController", RequestWorkOrderTabController);

  /* @ngInject */
  function RequestWorkOrderTabController(
    // Angular
    $timeout,
    // Resolves
    building,
    request,
    // Services
    ToastService,
    WorkOrderService
  ) {
    var self = this;

    // Attributes
    self.loading = true;
    self.rendering = true;
    self.building = building;
    self.request = request;
    self.workOrder = null;

    init();

    function init() {
      var workOrderId = request.task._id;
      WorkOrderService.getById(building._id, workOrderId)
        .then(function (workOrder) {
          self.workOrder = workOrder;
        })
        .catch(ToastService.showError)
        .finally(function () {
          self.loading = false;
          $timeout(function () {
            self.rendering = false;
          }, 500);
        });
    }
  }
})();
